<div class="survey-container overflow-hidden rounded predictor row">
  <div class="survey-header mb-1 col-12 col-lg-6">
    <div class="image-container">
      <img src="{{ survey.ImageURL | contentImage: '1' }}" alt="{{ survey.ImageURL }}" />
    </div>
    <div class="survey-info d-flex flex-column align-content-between text-white shadow bg-predictor">
      <div class="d-flex justify-content-between mb-4" *ngIf="!survey.HasBeenAnsweredByUser">
        <div class="d-flex align-items-center">
          <span class="icon-predictor svg svg-white d-inline-block my-0" [inlineSVG]="'assets/images/icons/nav-predictor.svg'">
          </span>
          <span class="ps-2 fw-bold">PREDICTOR</span>
        </div>
        <div class="text-end">
          <div class="font-size-12">Time left to play</div>
          <fgb-countdown
            [endDateTime]="survey.EndDate"
            [requestDateTime]="survey.RequestTime"
            [isUTC]="false"
            class="font-size-16 fw-bold"
          ></fgb-countdown>
        </div>
      </div>
      <div class="survey-title mb-3 fw-bold">
        <div>{{ survey.SurveyQuestion }}</div>
      </div>
      <div class="d-flex align-items-end mt-4 h-100">
        <button
          *ngIf="!survey.HasBeenAnsweredByUser"
          (click)="submitAnswer()"
          class="btn btn-success col-6 fw-bold mx-auto"
          [disabled]="disableSubmitButton"
        >
          Submit
        </button>
        <div class="d-flex flex-row w-100 justify-content-center my-1" *ngIf="survey.HasBeenAnsweredByUser">
          <span class="icon-predictor svg svg-black d-inline-block my-0 px-0" [inlineSVG]="'assets/images/icons/nav-predictor.svg'"> </span>
          <div class="text-uppercase font-italic fw-bold font-size-25 px-2">Entered</div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 col-lg-6">
    <ng-container *ngIf="survey.HasBeenAnsweredByUser; else answer">
      <fgb-survey-item-answer-completed-predictor [survey]="survey"></fgb-survey-item-answer-completed-predictor>
    </ng-container>
    <ng-template #answer>
      <div class="h-100 w-100 d-table">
        <div class="d-table-cell align-middle">
          <fgb-survey-item-answer #itemAnswer [survey]="survey" (predictorAnswers)="hasUserAnswered()"></fgb-survey-item-answer>
        </div>
      </div>
    </ng-template>
  </div>
</div>
